import {Component, OnDestroy, OnInit, ChangeDetectionStrategy} from '@angular/core';
import {Publisher} from './shared/domain/publisher.model';
import {Principal} from './core/auth/principal.service';
import {Router} from '@angular/router';
import {SnackBarService} from './core/services/snackbar.service';
import {AuthService} from './core/auth/auth.service';
import {PublisherListFilter, PublishersService} from './shared/services/publishers.service';
import {UserRole} from './core/auth/user-role.model';
import {Subscription} from 'rxjs';
import {ContentOwner} from './shared/domain/content-owner.model';
import {ContentOwnerService} from './shared/services/content-owner.service';
import {ServerErrorUtils} from './shared/utils/server-error-utils';

@Component({
    selector: 'ctv-mask-select',
    templateUrl: './mask-select.component.html',
    styleUrls: ['./mask-select.component.scss'],
    changeDetection: ChangeDetectionStrategy.Eager,
    standalone: false
})
export class MaskSelectComponent implements OnInit, OnDestroy {

  publishers: Publisher[] = [];
  contentOwners: ContentOwner[] = [];
  subscription = new Subscription();
  readonly userRoles = UserRole;

  loading = true;
  coLoading = false;
  pubLoading = false;

  constructor(public principal: Principal,
              private router: Router,
              private sbs: SnackBarService,
              private authService: AuthService,
              private service: PublishersService,
              private contentOwnerService: ContentOwnerService) {
  }

  ngOnInit(): void {
    this.loading = true;
    this.subscription.add(
      this.authService.identity().subscribe(() => {
        this.getUserPublishers();
        this.getUserCo();
        this.loading = false;
      })
    );
  }

  getUserPublishers() {
    if (this.principal.user.publisherIds && this.principal.user.publisherIds.length) {
      this.pubLoading = true;
      this.subscription.add(
        this.service.listPublishers({ids: this.principal.user.publisherIds} as PublisherListFilter).subscribe(publishers => {
          this.publishers = publishers.content;
          this.pubLoading = false;
        }, (error) => {
          this.pubLoading = false;
          ServerErrorUtils.serverValidationOrMsg(error, this.sbs, 'Error during while fetching publishers');
        })
      );
    }
  }

  getUserCo() {
    if (this.principal.user.contentOwnerIds && this.principal.user.contentOwnerIds.length) {
      this.coLoading = true;
      this.subscription.add(
        this.contentOwnerService.list({coIds: this.principal.user.contentOwnerIds}).subscribe(response => {
          this.coLoading = false;
          this.contentOwners = response.filter(co => this.principal.user.contentOwnerIds.includes(co.id));
        }, (error) => {
          this.coLoading = false;
          ServerErrorUtils.serverValidationOrMsg(error, this.sbs, 'Error during while fetching content owners');
        })
      );
    }
  }

  selectPublisher(publisherId: string) {
    this.principal.setMask(UserRole.PUBLISHER, publisherId);
    this.router.navigateByUrl(`/p/${publisherId}`);
  }

  mainDashboard() {
    this.principal.setMask(UserRole.ADMIN, null);
    this.router.navigateByUrl('/');
  }

  campaignsDashboard() {
    this.principal.setMask(UserRole.CAMPAIGN_MANAGER, null);
    this.router.navigateByUrl('/orders');
  }

  forecastDashboard() {
    this.principal.setMask(UserRole.REV_OPS, null);
    this.router.navigateByUrl('/forecast');
  }

  designerDashboard() {
    this.principal.setMask(UserRole.DESIGNER, null);
    this.router.navigateByUrl('/campaigns/creative-library');
  }

  advertiserDashboard() {
    this.principal.setMask(UserRole.ADVERTISER, null);
    this.router.navigateByUrl('/reports');
  }

  financeDashboard() {
    this.principal.setMask(UserRole.FINANCE, null);
    this.router.navigateByUrl('/reports');
  }

  coDashboard(coId: string) {
    this.principal.setMask(UserRole.CONTENT_OWNER, coId);
    this.router.navigateByUrl(`/co/${coId}`);
  }

  ngOnDestroy() {
    this.subscription.unsubscribe();
  }
}

